import { motion } from "framer-motion";
import { useState } from 'react';
import api from '../../api/api';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../config/utility';
import ThemeButton from "../../components/atoms/ThemeButton";
import SecondaryThemeButton from "../../components/atoms/SecondaryThemeButton";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/resend-otp', { email });
      navigate(routes.reset_password, { state: { email } });
    } catch (error) {
      console.error('Error sending OTP:', error);
    } finally {
      setLoading(false);
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };
  // f3efebc4
  return (
    <motion.div
      className="flex h-screen w-screen overflow-hidden bg-body-auth"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Right Image Panel */}
      <div className="w-full flex items-center justify-center relative backdrop-blur-lg">
        {/* Top Image Panel */}
        <motion.div
          className="absolute -top-0 left-30   max-w-lg z-10"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ type: "spring", duration: 0.8 }}
        >
          <img
            src="/assets/kids-header2.png"
            alt=""
            className="w-full h-full object-cover object-bottom"
          />


        </motion.div>

        {/* Forgot Password Card */}
        <motion.div
          className="sm:h-[calc(100vh-45vh)] flex flex-col justify-center relative w-full max-w-2xl mx-auto bg-white/85 border border-white/20 rounded-2xl p-8 backdrop-blur-md shadow-xl  sm:mt-24"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Header */}
          <motion.div
            className="text-center flex flex-col items-center justify-center mb-8"
            variants={itemVariants}
          >
            <motion.img
              src="/assets/FULLLOGO.svg"
              alt="Popout"
              className="w-64 mb-8 "
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", duration: 0.8 }}
            />
            <motion.h2
              className="text-2xl font-display font-bold text-dark"
              variants={itemVariants}
            >
              Forgot Password
            </motion.h2>
            <motion.p
              className="text-grey mt-2"
              variants={itemVariants}
            >
              Enter your email to receive a password reset OTP.
            </motion.p>
          </motion.div>

          <form onSubmit={handleForgotPassword} className="space-y-6">
            {/* Email Input */}
            <motion.div variants={itemVariants}>
              <label htmlFor="email" className="block text-sm mb-2">Email</label>
              <input
                type="email"
                id="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className=""
              />
            </motion.div>

            {/* Submit Button */}
            <motion.div
              variants={itemVariants}
              className="flex justify-center items-center w-full"
            >
              <ThemeButton
                type="submit"
                label={loading ? "Sending OTP..." : "Send OTP"}
                onClick={handleForgotPassword}
                disabled={loading}
                className="w-full max-w-xs"
                primaryColor="bg-secondary"
                secondaryColor="bg-accent"
                textColor="#ffffff"
                hoverTextColor="#160033"
              />
            </motion.div>
          </form>

          {/* Back to Login */}
          <motion.p
            variants={itemVariants}
            className="mt-8 text-sm text-center text-grey"
          >
            Remembered your password?{" "}
            <SecondaryThemeButton
              label="Back to Login"
              className="text-lg"
              onClick={() => navigate(routes.login)}
            />
          </motion.p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ForgotPassword;
